import React, { useEffect, useState } from 'react';

import { useSearchParams } from 'react-router-dom';

import { StyledUnsubscribePage } from './styles';
import { PageContainer } from '../../components/molecules/page-container';
import { Heading11, Paragraph1 } from '../../theme';
import { bemClassName } from '../../utils/bem';

const b = bemClassName('unsubscribe-page');

const UnsubscribePage = () => {
  const [searchParams] = useSearchParams();
  const token = searchParams.get('token');
  const [status, setStatus] = useState('loading');

  useEffect(() => {
    if (!token) {
      setStatus('error');

      return;
    }

    const unsubscribe = async () => {
      try {
        const response = await fetch(`${import.meta.env.VITE_API_URL}/users/unsubscribe/${token}`);

        if (response.ok) {
          setStatus('success');
        } else {
          setStatus('error');
        }
      } catch {
        setStatus('error');
      }
    };

    unsubscribe();
  }, [token]);

  return (
    <StyledUnsubscribePage>
      <PageContainer maxWidth={600}>
        <div className={b()}>
          {status === 'loading' && (
            <div className={b('content')}>
              <Paragraph1>Processing your request...</Paragraph1>
            </div>
          )}

          {status === 'success' && (
            <div className={b('content')}>
              <div className={b('icon')}>&#10003;</div>
              <div className={b('title')}>
                <Heading11>You&apos;ve been unsubscribed</Heading11>
              </div>
              <div className={b('message')}>
                <Paragraph1>
                  You won&apos;t receive this type of email from us anymore. You can always re-enable emails in your
                  account settings.
                </Paragraph1>
              </div>
            </div>
          )}

          {status === 'error' && (
            <div className={b('content')}>
              <div className={b('icon', { error: true })}>&#10007;</div>
              <div className={b('title')}>
                <Heading11>Something went wrong</Heading11>
              </div>
              <div className={b('message')}>
                <Paragraph1>
                  This unsubscribe link may be invalid or expired. You can manage your email preferences from your
                  account settings.
                </Paragraph1>
              </div>
            </div>
          )}
        </div>
      </PageContainer>
    </StyledUnsubscribePage>
  );
};

export default UnsubscribePage;
